<template></template>

<script>
import commonMixin from "@/core/mixins/common.mixin";
import { i18nHelper } from "@/core/utils";
import { ROUTE_NAME } from "@/core/constants";
import {
  AUTH_GET_LOGIN,
  AUTH_GET_TOKEN,
  AUTH_GET_PERMISSION,
  AUTH_INITIAL_GET_LOGIN_STATE,
  AUTH_INITIAL_GET_TOKEN_STATE,
  AUTH_INITIAL_GET_PERMISSION_STATE,
} from "@/core/store/auth.module";

export default {
  name: "login",
  mixins: [commonMixin],
  data: () => ({}),
  components: {
    // Logi,
  },
  created() {
    let code = this.$route.query.code;
    if (code) {
      this.getToken(code);
    } else {
      this.getLogin();
    }
  },
  computed: {
    getPermissionComplate() {
      return this.$store.state.auth.getLogin.complete;
    },
    getTokenComplate() {
      return this.$store.state.auth.getToken.complete;
    },
    getAuthPermissionComplate() {
      return this.$store.state.auth.getPermission.complete;
    },
  },
  watch: {
    getPermissionComplate() {
      let response = this.$store.state.auth.getLogin;
      if (response.complete) {
        this.authComplateAction(response, "getLogin");
      }
    },
    getTokenComplate() {
      let response = this.$store.state.auth.getToken;
      if (response.complete) {
        this.authComplateAction(response, "getToken");
      }
    },
    getAuthPermissionComplate() {
      let response = this.$store.state.auth.getPermission;
      if (response.complete) {
        this.authComplateAction(response, "getPermission");
      }
    },
  },
  methods: {
    authComplateAction(response, actionType) {
      let title = i18nHelper.getMessage("label.auth");
      let messages = response.message;
      let code = response.code;
      let buttons = [];

      switch (actionType) {
        case "getLogin":
          window.location.replace(response.data.url);
          this.initialGetLogin();
          break;
        case "getToken":
          this.initialGetToken();
          this.getPermission();
          break;
        case "getPermission":
          this.$router.push({
            name: ROUTE_NAME.HOME,
          });
          break;
      }
      /*
      if (response.code == 200) {
        buttons.push({
          text: i18nHelper.getMessage("label.ok"),
          variant: "primary",
          action: () => {
            this.closeLayoutAppModalInfo();
            switch (actionType) {
              case "getToken":
                this.$router.push({
                  name: ROUTE_NAME.HOME,
                });

                location.reload();
                break;
              default:
            }
          },
        });
      } else {
        buttons.push({
          text: i18nHelper.getMessage("label.ok"),
          variant: "primary",
          action: () => {
            this.closeLayoutAppModalInfo();
          },
        });
      }
      */
      if (messages) this.openLayoutAppModalInfo(title, messages, buttons, code);
    },
    getLogin() {
      this.$store.dispatch(AUTH_GET_LOGIN, {});
    },
    getToken(code) {
      let data = {
        code: code,
      };
      this.$store.dispatch(AUTH_GET_TOKEN, { data });
    },
    getPermission() {
      this.$store.dispatch(AUTH_GET_PERMISSION, {});
    },
    initialGetLogin() {
      this.$store.dispatch(AUTH_INITIAL_GET_LOGIN_STATE, {});
    },
    initialGetToken() {
      this.$store.dispatch(AUTH_INITIAL_GET_TOKEN_STATE, {});
    },
    initialGetPermission() {
      this.$store.dispatch(AUTH_INITIAL_GET_PERMISSION_STATE, {});
    },
  },
};
</script>

<style></style>
